export class PPCPoint3D {
  public x: number;
  public y: number;
  public z: number;

  public constructor(param1?: number | PPCPoint3D, param2?: number, param3?: number) {
    if (param1 === undefined) {
      this.x = this.y = this.z = 0;
    } else if (param1 instanceof PPCPoint3D) {
      const pt: PPCPoint3D = param1;
      this.x = pt.x;
      this.y = pt.y;
      this.z = pt.z;
    } else {
      this.x = param1;
      this.y = param2 ?? 0;
      this.z = param3 ?? 0;
    }
  }
}
